import { render, h } from 'preact';

import RaceApp from './componentsV2/RaceApp';
import parseQueryString from './utils/parse-query-string';

const { contest } = parseQueryString(location.search);

const selectedContest = Array.isArray(contest) ? contest[0] : contest;

render(<RaceApp contest={selectedContest} />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./race-embed.js